<template>
  <div>
    <v-container
      class="full-height"
      fluid
    >
      <report-probation-probation-report
        v-if="$hasPermissionTo(['generate probation report'])"
        class="mb-2"
      />
    </v-container>
  </div>      
</template>
<script>
 
  export default {
    components: {
      ReportProbationProbationReport: () => import('@/components/hris/reports/probation/ProbationReport'),
    },
  }
</script>
